export enum MembershipScope {
    ALL = `ALL`,
    STARTER = `STARTER`,
    UPME = `UPME`,
}